import type { Board } from "../board";
import { Hit } from "../effects/hit";
import { MovementEffect, STANDARD_MOVEMENT_TIME } from "../effects/movementEffect";
import { PRIORITY_FIRST, type ProcessableThing } from "../interfaces";
import { Mob } from "../mob";
import { PhysicalThing } from "../physicalThing";
import { deserializeXY } from "../serialization";
import type { XY } from "../xy";
import { ZOrder } from "../zOrder";
import { DevGunAutoKillBotProjectile } from "./devGunAutoKillBotProjectile";

const KILL_RADIUS = 3;

export class DevGunAutoKillBot extends PhysicalThing implements ProcessableThing {
	static key = "DevGunAutoKillBot";
	constructor(xy: XY) {
		super(xy, false);
	}

	isPassable(): boolean {
		return true;
	}

	override isVisible(): boolean {
		return false;
	}

	override getZOrder(): number {
		return ZOrder.TILE;
	}

	override isHideUnderneath(): boolean {
		return false;
	}

	processTurn(board: Board): void {
		const player = board.player;
		if (!player) return;
		this.xy = player.xy;

		const area = this.xy.getAreaInSquareRadius(KILL_RADIUS);
		const mobsToKill = new Set<Mob>();
		for (const pos of area) {
			if (!board.isInBounds(pos)) continue;
			for (const thing of board.getThingsAt(pos)) {
				if (thing.active && thing instanceof Mob) {
					mobsToKill.add(thing);
				}
			}
		}

		for (const mob of mobsToKill) {
			if (mob.active) {
				mob.kill();
				board.addEffect(new Hit(mob.xy));
				if (!this.xy.equals(mob.xy)) {
					const projectile = new DevGunAutoKillBotProjectile(this.xy);
					board.addEffect(new MovementEffect(projectile, this.xy, mob.xy, STANDARD_MOVEMENT_TIME * 0.5));
				}
			}
		}
	}

	getProcessPriority(): number {
		return PRIORITY_FIRST + 1;
	}

	static deserialize(data: any): DevGunAutoKillBot {
		const bot = new DevGunAutoKillBot(deserializeXY(data.xy));
		bot.visualId = data.visualId;
		return bot;
	}
}
